import { render, staticRenderFns } from "./EditMemberList.vue?vue&type=template&id=0b8a2c84&"
import script from "./EditMemberList.vue?vue&type=script&lang=js&"
export * from "./EditMemberList.vue?vue&type=script&lang=js&"
import style0 from "./EditMemberList.vue?vue&type=style&index=0&id=0b8a2c84&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports